import { ReservationPolicyModel, ReservationPolicyType } from "src/api/product/product-types";

const DETAILS_KEY_BY_POLICY_TYPE = {
  "start-time-policy": "startTimePolicy",
  "usage-limit-policy": "usageLimitPolicy",
  "closing-time-policy": "closingTimePolicy",
} as const;

/**
 * 찾는 정책 타입이 맞는지. 조회 시 policyType 으로 걸러 받지만,
 * 다른 정책 타입이 섞여 오면 같은 공간의 엉뚱한 정책을 집어 빈 값으로 보이므로 한 번 더 확인한다.
 * key.policyType 이 비어 내려오는 환경 대비로 details 쪽도 함께 본다.
 */
const isPolicyType = (policy: ReservationPolicyModel, policyType: ReservationPolicyType): boolean =>
  policy.key?.policyType === policyType || !!policy.details?.[DETAILS_KEY_BY_POLICY_TYPE[policyType]];

/**
 * 공용공간 타입 전체에 적용되는 기본 정책. scope 에 facilityId 가 없고 facilityType 만 있다.
 * 미설정 facilityId 가 빈 문자열로 내려올 수 있어 `== null` 이 아닌 falsy 판정을 쓴다.
 */
export const findDefaultReservationPolicy = (
  policies: ReservationPolicyModel[] | undefined,
  policyType: ReservationPolicyType,
  facilityType?: string,
): ReservationPolicyModel | undefined =>
  (policies ?? []).find((policy) => isPolicyType(policy, policyType) && !policy.key?.scope?.facilityId && policy.key?.scope?.facilityType === facilityType);

/**
 * 개별 공간에 지정된 정책. 없으면 그 공간은 기본 정책을 따른다.
 */
export const findFacilityReservationPolicy = (
  policies: ReservationPolicyModel[] | undefined,
  policyType: ReservationPolicyType,
  facilityId?: string | number,
): ReservationPolicyModel | undefined =>
  facilityId === undefined || facilityId === null || facilityId === ""
    ? undefined
    : (policies ?? []).find((policy) => isPolicyType(policy, policyType) && String(policy.key?.scope?.facilityId ?? "") === String(facilityId));
